import Translate from "components/common/Translate";
import { DatalistTableColumnType } from "types/datalist-types";


const DatalistTableHeaderItem = <TItemType, TFilterType, TSortType> (props: {column: DatalistTableColumnType<TItemType, TFilterType, TSortType>}) => {
    const { column } = props;
    let label:any = <></>;
    if(column.title === '') {
        label = <></>;   
    }
    else if (typeof column.title == 'string' && column.title) {
        label = <span className="font-bold text-sm pb-1 app-label">
            <Translate i18nKey={column.title} />
        </span>;
    } else if(typeof column.title == 'object') {
        label = column.title;
    } else if(!column.title) {
        label = <span className="font-bold text-sm pb-1 app-label">
            <Translate i18nKey={`fields.${column.name}.shortName`} />
        </span>; 
    }

    return label;
}

export default DatalistTableHeaderItem;
